export const focusablesSelector = 'button, [href], input, select, textarea, [role="menuitem"], [tabindex]:not([tabindex="-1"])';

export const findFocusableChild = (element) => element.querySelector(focusablesSelector);

export const focusFocusableChild = (element) => {
  const focusable = findFocusableChild(element);
  focusable.focus();
  (focusable || element).focus();
};

export const hasModifierKey = (event) => event instanceof KeyboardEvent &&
  (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
